import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { OAuthModule } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppCoreModule } from './core/app-core.module';
import { HttpErrorInterceptor } from './core/interceptor/http-error.interceptor';
import { SharedModule } from './shared/shared.module';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';

registerLocaleData(localePt, 'pt');

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule.forRoot(),
        AppCoreModule.forRoot(),
        OAuthModule.forRoot({
            resourceServer: {
                allowedUrls: [`${environment.api_url}`, 'https://dsv-enderecos.rs.pm.df.gov.br/api'],
                sendAccessToken: true,
            },
        }),
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'pt' },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline' },
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
        }
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
